import { render } from "./CheckboxInput.vue?vue&type=template&id=5f3d918e&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=5f3d918e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f3d918e"

export default script